module.exports = __webpack_public_path__ + "img/quality_en.11ad279e.png";